module.exports = __webpack_public_path__ + "static/media/LATINS_TERRASSE-COMMUNS.9fdb42f5.jpg";